﻿export default {
    name: 'receipt-confirmation-section',
    mounted() {
        var section = document.querySelector('#mittelia');
        var items = section.querySelectorAll('.ts-checklist__item');
        for (var i = 0; i < items.length; i++) {
            // access to individual element:
            var elem = items[i];
            var temp = elem.innerHTML;
            elem.innerHTML = '<svg role= "img" class="ts-symbol ts-symbol--tick ts-checklist__symbol ts-checklist__symbol--success" aria-hidden="true" > <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/UI/ECommerce/images/sprite/svg-symbols.svg#tick" /></svg>' + temp;
        }
    }
}
